import { render, staticRenderFns } from "./ChangeStatusClientsHeader.vue?vue&type=template&id=7bddc27f&"
import script from "./ChangeStatusClientsHeader.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusClientsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports